import { t } from "i18next";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { emptyUser, User } from "../../interfaces/user";
import { getUserSingle, updateUserProfile } from "../../services/user";
import { LoadingSpinner } from "../general/loading-spinner";

interface AdminUserEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function ProfileEdit(props: AdminUserEditProps) {
    const [user, setUser] = useState<User>(emptyUser);

    useEffect(() => {
        getUserSingle(props.id)
            .then(response => {
                setUser(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            first_name: event.target.first_name.value,
            last_name: event.target.last_name.value,
            phone: event.target.phone.value,
            document_id: event.target.document_id.value,
            birthdate: event.target.birthdate.value
        }
        updateUserProfile(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="admin-user-new-container" show={ true }
            onHide={ handleClose } size="lg"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_user") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { user.id == 0 && 
                    <LoadingSpinner />
                }
                { user.id != 0 && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Container>
                                <Row>
                                    <Form.Control type="hidden" name="id" required defaultValue={ user.id }/>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="first_name">
                                            <Form.Label aria-required="true">{ t("first_name") }</Form.Label>
                                            <Form.Control type="text" name="first_name" required defaultValue={ user.first_name }/>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="last_name">
                                            <Form.Label aria-required="true">{ t("last_name") }</Form.Label>
                                            <Form.Control type="text" name="last_name" required defaultValue={ user.last_name } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="email">
                                            <Form.Label>{ t("email") }</Form.Label>
                                            <Form.Control type="text" name="email" defaultValue={ user.email } disabled />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="phone">
                                            <Form.Label>{ t("phone") }</Form.Label>
                                            <Form.Control type="text" name="phone" defaultValue={ user.phone } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="document_id">
                                            <Form.Label>{ t("document_id") }</Form.Label>
                                            <Form.Control type="text" name="document_id" defaultValue={ user.document_id } />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="birthdate">
                                            <Form.Label aria-required="true">{ t("birthdate") }</Form.Label>
                                            <Form.Control type="date" name="birthdate" required defaultValue={ user.birthdate } />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}